



import React, {useEffect, useState} from 'react';
import { useHistory ,useLocation} from 'react-router-dom';
import {Form, Input  } from 'semantic-ui-react';
import { Grid, Segment ,Button } from 'semantic-ui-react';
import Spinner from "../common/Spinner";
import styled from "styled-components";
import 'rc-slider/assets/index.css';
import ApiUtils from "../../helper/ApiUtils";

const Language_Add = ({type,editData,finishUpdate}) => {
    this.captionTextRef = React.createRef();

    const history = useHistory();
    const location = useLocation();

    //網址判斷
    useEffect(() => {

        // post_Style_GetClientList
         getClient();

    }, [location]);


    const [loading,setloading] = useState(false);
    const [clientList,setclientList] = useState(null);

    const getClient = async ()=>{

//         /**
//          * 廠商
//          * */
//         const getClient_jsonData = await ApiUtils.post_sql(`${ApiUtils.post_Style_AddLanguage}`);
//         // [{"fId":1,"fName":"Medialink Group Ltd.","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1},{"fId":2,"fName":"酷遊天國際旅行社股份有限公司","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1}]
//
// 　
//         //客戶列表
//         let clients = [];
//         getClient_jsonData.map((data)=>{
//             const {fId,fName} = data;
//             clients.push({ key: fId, value: fId, text: fName })
//         });
//         setclientList(clients);

        /**
         * 基本資料拿完後，開始設定編輯內容
         * */　
        if(type === 'edit'){
            //分配數值
            setfId(editData.fId);
            setfName(editData.fName);
            setfCode(editData.fCode);
            setfCountry(editData.fCountry);
        }

    }


    const [fId,setfId] = useState(0);
    const [fName,setfName] = useState('');
    const [fCode,setfCode] = useState('');
    const [fCountry,setfCountry] = useState('');


    //儲存
    const SaveAddStyle = async ()=>{

        let sqlData = {
            fName:fName,
            fCode:fCode,
            fCountry:fCountry
        };

        if(type !== 'Add'){
            //編輯 要加上ID
        }

        await ApiUtils.post_sql(`${ApiUtils.post_Style_AddLanguage}`,{
            postLanguage:sqlData,
            fLanguageId:fId
        });

        finishUpdate();

        window.location.reload();
    }

    /** 最後處理的按鈕*/
    const actionbutton = ()=>{

        if(type === 'add'){
            return <div>
                <Button color='teal' onClick={()=>{
                    SaveAddStyle();
                }}>
                    Save
                </Button>
            </div>
        }else{
            return <div>
                <Button color='teal' onClick={()=>{
                    SaveAddStyle();
                }}>
                    Save Edit
                </Button>
            </div>
        }

    }

    return <div className=' pb-2 position-relative' >

        {(loading===true)?<Spinner/>:<div className='p-5'>

            <Grid divided='vertically'>

                <Grid.Row columns={1}>
                    <Grid.Column className='p-0'  >
                        <Form>
                            <Segment>
                                <Form.Group widths='equal'>
                                    <Form.Field >
                                        <label>Name</label>
                                        <Input
                                            placeholder='Name'
                                            autoFocus
                                            type="text"
                                            value={fName}
                                            onChange={(e) => {
                                                setfName(e.target.value)
                                            }} />
                                    </Form.Field>
                                    <Form.Field >
                                        <label>Code</label>
                                        <Input
                                            type="text"
                                            placeholder='Code'
                                            value={fCode}
                                            onChange={(e) => {
                                                setfCode(e.target.value)
                                            }} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Country</label>
                                        <Input
                                            type="text"
                                            placeholder='Country'
                                            value={fCountry}
                                            onChange={(e) => {
                                                setfCountry(e.target.value)
                                            }} />
                                    </Form.Field>
                                </Form.Group>

                            </Segment>
                        </Form>

                        {actionbutton()}
                    </Grid.Column>

                </Grid.Row>
            </Grid>



        </div>}
    </div>;
};

export default Language_Add;



// WEBPACK FOOTER //
// ./src/components/Language/Language_Add.js